export default "__VITE_ASSET__D9TpN7pk__"